import { render, staticRenderFns } from "./mall_diamond.vue?vue&type=template&id=da3922d0&scoped=true"
import script from "./mall_diamond.vue?vue&type=script&lang=ts"
export * from "./mall_diamond.vue?vue&type=script&lang=ts"
import style0 from "./mall_diamond.vue?vue&type=style&index=0&id=da3922d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3922d0",
  null
  
)

export default component.exports